﻿/* assets/lfdl-youtube-playlists.js */
(function () {
  "use strict";

  var CACHE_PREFIX = "lfdl_yt_v9_"; // Version bump
  var DEFAULT_CACHE_MINUTES = 60;

  function find(sel, ctx) { return (ctx || document).querySelector(sel); }
  function findAll(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function nowTs() { return Date.now(); }
  function toInt(v, d) {
    var n = parseInt(String(v || ""), 10);
    return Number.isFinite(n) ? n : d;
  }

  function escHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function normalizePlaylistId(value) {
    var raw = String(value || "").trim();
    if (!raw) return "";
    if (/^PL[A-Za-z0-9_-]+$/.test(raw)) return raw;
    try {
      var u = raw.indexOf("http") === 0 ? new URL(raw) : null;
      if (u) {
        var listId = (u.searchParams.get("list") || "").trim();
        if (listId) return listId;
      }
    } catch (e) {}
    return raw;
  }

  // Cache
  function getCache(key) {
    try {
      var item = JSON.parse(localStorage.getItem(key));
      if (!item || nowTs() > item.expiry) return null;
      return item.data;
    } catch (e) { return null; }
  }

  function setCache(key, data, mins) {
    try {
      var expiry = nowTs() + (mins * 60 * 1000);
      localStorage.setItem(key, JSON.stringify({ data: data, expiry: expiry }));
    } catch (e) {}
  }

  // API helper
  function ytFetch(endpoint, params, apiKey) {
    var url = new URL("https://www.googleapis.com/youtube/v3/" + endpoint);
    url.searchParams.set("key", apiKey);
    Object.keys(params).forEach(function (k) { url.searchParams.set(k, params[k]); });

    return fetch(url.toString()).then(function (res) {
      if (!res.ok) throw new Error(String(res.status));
      return res.json();
    });
  }

  function formatCount(num) {
    if (!num) return "0";
    num = Number(num);
    if (Number.isNaN(num)) return "0";
    if (num >= 1000000) return (num / 1000000).toFixed(1) + "M";
    if (num >= 1000) return (num / 1000).toFixed(1) + "k";
    return String(num);
  }

  function initSection(section) {
    if (!section || section.dataset.lfdlYtReady === "1") return;
    section.dataset.lfdlYtReady = "1";

    var config = section.dataset;
    var apiKey = config.apiKey;

    if (!apiKey || apiKey.includes("REPLACE")) return;

    var showStats = {
      views: config.showViews === "true",
      likes: config.showLikes === "true",
      comments: config.showComments === "true",
      date: config.showPublishDate === "true"
    };

    // Header chaine
    if (config.showChannelHeader === "true") {
      loadChannelInfo(section, config.channelId, apiKey);
    }

    // Playlists
    var playlists = findAll("[data-playlist]", section);

    var loadPl = function (pl) {
      if (pl.dataset.loaded === "true") return;
      loadPlaylistVideos(pl, apiKey, showStats);
    };

    if (section.classList.contains("lfdl-yt--stack")) {
      playlists.forEach(loadPl);
    } else {
      var activePl = section.querySelector(".lfdl-yt__playlist.is-active") || playlists[0];
      if (activePl) loadPl(activePl);
    }

    // Tabs
    var tabs = findAll(".lfdl-yt__tab", section);
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        tabs.forEach(function (t) {
          t.classList.remove("is-active");
          t.setAttribute("aria-selected", "false");
        });
        playlists.forEach(function (p) { p.classList.remove("is-active"); });

        tab.classList.add("is-active");
        tab.setAttribute("aria-selected", "true");
        var targetId = tab.dataset.blockId;
        var targetPl = section.querySelector('[data-playlist][data-block-id="' + targetId + '"]');

        if (targetPl) {
          targetPl.classList.add("is-active");
          loadPl(targetPl);
        }
      });
    });

    // Fleches onglets
    var tabsWrap = find(".lfdl-yt__tabs-wrap", section);
    var arrows = findAll("[data-tabs-arrow]", section);
    if (tabsWrap && arrows.length) {
      arrows.forEach(function (btn) {
        btn.addEventListener("click", function () {
          var dir = btn.getAttribute("data-tabs-arrow");
          var delta = (dir === "left" ? -200 : 200);
          tabsWrap.scrollBy({ left: delta, behavior: "smooth" });
        });
      });
    }

    // Fleches videos (mode onglets, une seule ligne scrollable)
    findAll("[data-videos-arrow]", section).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var list = btn.closest("[data-list]");
        if (!list) return;
        var items = find("[data-items]", list);
        if (!items) return;

        var dir = btn.getAttribute("data-videos-arrow");
        var firstCard = items.querySelector(".lfdl-yt__card");
        var isMobile = window.matchMedia("(max-width: 749px)").matches;
        var count = isMobile ? 2 : 4;
        var styles = window.getComputedStyle(items);
        var gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
        var cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 0;
        var step = firstCard
          ? Math.max(220, Math.round((cardWidth * count) + (gap * Math.max(0, count - 1))))
          : Math.max(260, Math.round(items.clientWidth * 0.92));
        var delta = dir === "left" ? -step : step;

        items.scrollBy({ left: delta, behavior: "smooth" });
      });
    });
  }

  function loadChannelInfo(section, channelId, apiKey) {
    var container = find("[data-channel]", section);
    if (!container) return;

    if (!channelId) {
      renderChannelHeader(container, {
        snippet: {
          title: section.dataset.channelName || "",
          thumbnails: { medium: { url: section.dataset.channelAvatar || "" } }
        },
        statistics: {
          subscriberCount: section.dataset.channelSubscribers || "0",
          videoCount: section.dataset.channelVideos || "0"
        }
      });
      return;
    }

    var cacheKey = CACHE_PREFIX + "channel_" + channelId;
    var cached = getCache(cacheKey);
    if (cached) { renderChannelHeader(container, cached); return; }

    ytFetch("channels", { part: "snippet,statistics", id: channelId }, apiKey)
      .then(function (data) {
        if (data.items && data.items.length) {
          var ch = data.items[0];
          setCache(cacheKey, ch, 120);
          renderChannelHeader(container, ch);
        }
      })
      .catch(function () {
        renderChannelHeader(container, {
          snippet: {
            title: section.dataset.channelName || "",
            thumbnails: { medium: { url: section.dataset.channelAvatar || "" } }
          },
          statistics: {
            subscriberCount: section.dataset.channelSubscribers || "0",
            videoCount: section.dataset.channelVideos || "0"
          }
        });
      });
  }

  function renderChannelHeader(container, data) {
    var snippet = data.snippet || {};
    var stats = data.statistics || {};
    var sec = container.closest(".lfdl-yt");
    var channelUrl = (sec && sec.dataset && sec.dataset.channelUrl) ? sec.dataset.channelUrl : "";

    var subscribeHtml = channelUrl
      ? '<a class="button lfdl-yt__subscribe" href="' + channelUrl + '?sub_confirmation=1" target="_blank" rel="noopener">S\'abonner</a>'
      : "";

    var thumb = (snippet.thumbnails && snippet.thumbnails.medium && snippet.thumbnails.medium.url) ? snippet.thumbnails.medium.url : "";

    container.innerHTML =
      '<div class="lfdl-yt__channel-main">' +
        '<div class="lfdl-yt__channel-avatar">' +
          '<img src="' + thumb + '" alt="' + (snippet.title || "") + '" width="80" height="80" loading="lazy">' +
        '</div>' +
        '<h2 class="lfdl-yt__channel-name">' + escHtml(snippet.title || "") + '</h2>' +
        '<div class="lfdl-yt__channel-stats">' +
          '<span class="lfdl-yt__channel-stat-num">' + formatCount(stats.subscriberCount) + '</span> abonnés &bull; ' +
          '<span class="lfdl-yt__channel-stat-num">' + formatCount(stats.videoCount) + '</span> vidéos' +
        "</div>" +
        (subscribeHtml ? ('<div class="lfdl-yt__channel-action">' + subscribeHtml + "</div>") : "") +
      "</div>";
  }

  function loadPlaylistVideos(plElement, apiKey, opts) {
    if (plElement.dataset.loading === "true" || plElement.dataset.loaded === "true") return;
    plElement.dataset.loading = "true";

    var loader = find("[data-loading]", plElement);
    var itemsWrap = find("[data-items]", plElement);
    var raw = (plElement.dataset.playlistId || "").trim();

    if (!raw) {
      if (loader) loader.innerHTML = "ID manquant";
      plElement.dataset.loading = "false";
      return;
    }

    var playlistIds = raw
      .split(/[\n,;|]+/)
      .map(function (s) { return normalizePlaylistId(s); })
      .filter(Boolean);
    var currentIdx = 0;

    function fetchNext() {
      if (currentIdx >= playlistIds.length) {
        if (loader) loader.innerHTML = "Videos indisponibles";
        plElement.dataset.loading = "false";
        plElement.dataset.loaded = "false";
        return;
      }

      var pid = playlistIds[currentIdx++];
      var cacheKey = CACHE_PREFIX + "pl_full_" + pid;
      var cached = getCache(cacheKey);

      if (cached) {
        if (loader) loader.remove();
        renderVideos(itemsWrap, cached, opts);
        plElement.dataset.loaded = "true";
        plElement.dataset.loading = "false";
        return;
      }

      ytFetch("playlistItems", { part: "snippet,contentDetails", playlistId: pid, maxResults: 12 }, apiKey)
        .then(function (data) {
          if (!data.items || !data.items.length) throw new Error("empty");

          var vids = data.items.map(function (i) {
            var sn = i.snippet || {};
            var th = (sn.thumbnails && (sn.thumbnails.medium || sn.thumbnails.default)) ? (sn.thumbnails.medium || sn.thumbnails.default) : {};
            return {
              id: (i.contentDetails && i.contentDetails.videoId) ? i.contentDetails.videoId : "",
              title: sn.title || "",
              thumb: th.url || "",
              publishedAt: sn.publishedAt || ""
            };
          }).filter(function (v) { return v.id; });

          // Stats (vues, likes, commentaires), on recupere pour garantir l'affichage demande
          var ids = vids.map(function (v) { return v.id; }).join(",");
          return ytFetch("videos", { part: "statistics", id: ids }, apiKey)
            .then(function (statsData) {
              var statsMap = {};
              (statsData.items || []).forEach(function (item) { statsMap[item.id] = item.statistics || {}; });

              vids.forEach(function (v) {
                var st = statsMap[v.id] || {};
                v.views = st.viewCount;
                v.likes = st.likeCount;
                v.comments = st.commentCount;
              });

              setCache(cacheKey, vids, DEFAULT_CACHE_MINUTES);
              if (loader) loader.remove();
              renderVideos(itemsWrap, vids, opts);
              plElement.dataset.loaded = "true";
              plElement.dataset.loading = "false";
            });
        })
        .catch(function () {
          fetchNext();
        });
    }

    fetchNext();
  }

  function escAttr(s) {
    return String(s || "").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  function renderVideos(container, videos, opts) {
    if (!container) return;

    container.innerHTML = videos.map(function (v) {
      var metas = [];
      if (v.views && opts && opts.views) metas.push(formatCount(v.views) + " vues");
      if (v.likes && opts && opts.likes) metas.push(formatCount(v.likes) + " likes");
      if (v.comments && opts && opts.comments) metas.push(formatCount(v.comments) + " commentaires");
      if (v.publishedAt && opts && opts.date) metas.push(new Date(v.publishedAt).toLocaleDateString("fr-FR"));

      var safeTitle = escAttr(v.title);
      var safeTitleText = escHtml(v.title);
      var ytUrl = "https://www.youtube.com/watch?v=" + encodeURIComponent(v.id);

      return (
        '<a href="' + ytUrl + '" class="lfdl-yt__card" title="' + safeTitle + '" aria-label="' + safeTitle + '" onclick="openVideo(\'' + v.id + '\'); return false;">' +
          '<div class="lfdl-yt__thumb">' +
            '<img src="' + v.thumb + '" loading="lazy" width="320" height="180" alt="' + safeTitle + '">' +
            '<div class="lfdl-yt__play-icon"><span class="lfdl-yt__play-icon-triangle"></span></div>' +
          '</div>' +
          '<div class="lfdl-yt__card-body">' +
            '<h4 class="lfdl-yt__card-title">' + safeTitleText + '</h4>' +
            '<div class="lfdl-yt__card-meta">' + metas.join(" &bull; ") + "</div>" +
          "</div>" +
        "</a>"
      );
    }).join("");
  }

  window.openVideo = function (id) {
    var modal = document.createElement("div");
    modal.className = "lfdl-yt__modal is-open";
    modal.innerHTML =
      '<div class="lfdl-yt__player">' +
        '<button class="lfdl-yt__modal-close" onclick="this.closest(\'.lfdl-yt__modal\').remove()">x</button>' +
        '<iframe src="https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0" title="Lecteur YouTube" allow="autoplay; encrypted-media" allowfullscreen></iframe>' +
      "</div>";

    document.body.appendChild(modal);
    modal.addEventListener("click", function (e) { if (e.target === modal) modal.remove(); });
  };

  var boot = function () {
    findAll(".lfdl-yt").forEach(initSection);
  };

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();

